import ReducerGenerator from '../../lib/ReducerGenerator'

const generator = new ReducerGenerator('rates_batch', '/rates_batches')
const reducer = generator.generate()

export default reducer
